import React from "react";
import { CustomerBaiscDetailsLayout } from "../../CustomerBasicDetailsLayout/CustomerBasicDetailsLayout";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { StandadCard } from "../../../../../components/Cards";
import { Box } from "@mui/material";
import { PolicyTabCard } from "../../../../../components/PolicyTabCard/PolicyTabCard";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../hooks";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { BreadcrumbProvider } from "../../../../../contexts/BreadcrumbProvider/BreadcrumbProvider";
import { fetchCommAutomobileCustomerInfoAsync } from "../../../../../redux/commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsActions";
import { Update } from "@mui/icons-material";

export const CommAutomobilePolicyLayout: React.FC = () => {
  const { customerId, customerPolicyId } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
  };
  const {
    customerPoliycId: savedCustomerPolicyId,
    customerInfo: { loading, error },
  } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails
  );
  const navigate = useNavigate();
  const dispatch = useDispatchWrapper();
  const location = useLocation();
  const currentPathname = location.pathname;
  const isMainTab = currentPathname.includes("basic-details");

  const handleStep = (step: string) => () => {
    // const isAlreadyInSamePage = currentPathname.includes(step);
    // if (!isAlreadyInSamePage) {
    navigate(
      `/comm-automobile-policy/${customerId}/${step}/${savedCustomerPolicyId}?tab=0`
    );
    // }
  };

  const renderComponent = () => {
    if (isMainTab) {
      return <Outlet />;
    } else if (!isMainTab && !customerPolicyId) {
      return <Navigate to={`/customer-overview/${customerId}`} />;
    } else if (!isMainTab && savedCustomerPolicyId) {
      return <Outlet context={[customerId, savedCustomerPolicyId]} />;
    } else {
      console.log("__FALIED____");
      return null;
    }
  };

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileCustomerInfoAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  React.useEffect(() => {
    return () => {
      dispatch({ type: "CLEAR_POLICY_STATE" });
    };
  }, []);

  return (
    <>
      <BreadcrumbProvider>
        <CustomerBaiscDetailsLayout
          customerId={customerId}
          fromPolicy
          policyId={savedCustomerPolicyId as number}
        >
          <StandadCard sx={{ mb: 1 }}>
            <Box display={"flex"} flexWrap={"wrap"}>
              <PolicyTabCard
                label="Basic Details"
                onClick={handleStep("basic-details")}
                isSelected={currentPathname.includes("basic-details")}
              />
              <PolicyTabCard
                label="Driver"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("driver-tab")}
                isSelected={currentPathname.includes("driver-tab")}
              />
              <PolicyTabCard
                label="Vehicle"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("vehicle-tab")}
                isSelected={currentPathname.includes("vehicle-tab")}
              />
              <PolicyTabCard
                label="Garage Plates"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("garage-plate-tab")}
                isSelected={currentPathname.includes("garage-plate-tab")}
              />
              {/* <PolicyTabCard
                label="Commercial Vehicle Supplement"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("comm-vehicle-supplement-tab")}
                isSelected={currentPathname.includes(
                  "comm-vehicle-supplement-tab"
                )}
              /> */}
              <PolicyTabCard
                label="Coverage"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("vehicle-coverage-schedule-tab")}
                isSelected={currentPathname.includes(
                  "vehicle-coverage-schedule-tab"
                )}
              />
              <PolicyTabCard
                label="Applications"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("application-tab")}
                isSelected={currentPathname.includes("application-tab")}
              />

              <PolicyTabCard
                label="Marketing"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("marketing-tab")}
                isSelected={currentPathname.includes("marketing-tab")}
              />
              <PolicyTabCard
                label="Premium Finance"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("premium-finance")}
                isSelected={currentPathname.includes("premium-finance")}
              />

              {/* <PolicyTabCard
                label="Policy Notes"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("policy-notes")}
                isSelected={currentPathname.includes("policy-notes")}
              /> */}

              <PolicyTabCard
                label="Policy Forms"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("policy-forms-tab")}
                isSelected={currentPathname.includes("policy-forms-tab")}
              />
              <PolicyTabCard
                label="G4 Sign"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("g4-sign")}
                isSelected={currentPathname.includes("g4-sign")}
              />
              <PolicyTabCard
                label="Updates"
                icon={Update}
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("updates")}
                isSelected={currentPathname.includes("updates")}
              />

              <PolicyTabCard
                label="Attachments"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("attachments-tab")}
                isSelected={currentPathname.includes("attachments-tab")}
              />
              <PolicyTabCard
                label="Telematics"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("telematics")}
                isSelected={currentPathname.includes("telematics")}
              />
              <PolicyTabCard
                label="My Proof of Insurance"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("csio-mpoi")}
                isSelected={currentPathname.includes("csio-mpoi")}
              />
              <PolicyTabCard
                label="Policy Changes/Upload"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("policy-change-request-list")}
                isSelected={currentPathname.includes(
                  "policy-change-request-list"
                )}
              />
              <PolicyTabCard
                label="Contacts"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("contacts")}
                isSelected={currentPathname.includes("contacts")}
              />
              <PolicyTabCard
                label="eDocs"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("csio-edocs-list")}
                isSelected={currentPathname.includes("csio-edocs-list")}
              />
              <PolicyTabCard
                label="Activities"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("all-tasks")}
                isSelected={currentPathname.includes("all-tasks")}
              />
              <PolicyTabCard
                label="Invoices"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("invoices")}
                isSelected={currentPathname.includes("invoices")}
              />
                <PolicyTabCard
                label="Certificate of Insurance"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("certificate-of-insurance")}
                isSelected={currentPathname.includes("certificate-of-insurance")}
              />
              {/* <PolicyTabCard
                label="Abeyance/Notes"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("notes-tab")}
                isSelected={currentPathname.includes("notes-tab")}
              /> */}

              {/* <PolicyTabCard
                label="Invoice Payment"
                disabled={!savedCustomerPolicyId}
                onClick={handleStep("invoices/payments")}
                isSelected={currentPathname.includes("invoices/payments")}
              /> */}
            </Box>
          </StandadCard>
          <PageLoader
            loading={loading === LoadState.InProgress}
            error={error ? { message: error } : null}
          >
            {renderComponent()}
          </PageLoader>
        </CustomerBaiscDetailsLayout>
      </BreadcrumbProvider>
    </>
  );
};
